import {DOCUMENT} from '@angular/common';
import {ApplicationRef,DestroyRef,Injectable,InjectionToken,NgZone,inject,signal} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {Observable,filter,take} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
export const APP_RELOAD=new InjectionToken<()=>void>('APP_RELOAD',{providedIn:'root',factory:()=>()=>location.reload()});
export const APP_STABLE=new InjectionToken<Observable<boolean>>('APP_STABLE',{providedIn:'root',factory:()=>inject(ApplicationRef).isStable});
@Injectable({providedIn:'root'})
export class AppUpdateService {
 private readonly worker=inject(SwUpdate,{optional:true});
 private readonly destroy=inject(DestroyRef);
 private readonly document=inject(DOCUMENT);
 private readonly zone=inject(NgZone);
 private readonly reload=inject(APP_RELOAD);
 readonly available=signal(false);
 readonly applying=signal(false);
 readonly error=signal('');
 private checking=false;
 constructor(){
  if(!this.worker?.isEnabled)return;
  this.worker.versionUpdates.pipe(takeUntilDestroyed(this.destroy)).subscribe(event=>{if(event.type==='VERSION_READY')this.zone.run(()=>this.available.set(true));});
  this.worker.unrecoverable.pipe(takeUntilDestroyed(this.destroy)).subscribe(()=>this.zone.run(()=>this.available.set(true)));
  inject(APP_STABLE).pipe(filter(Boolean),take(1),takeUntilDestroyed(this.destroy)).subscribe(()=>{
   void this.check();
   const visible=()=>{if(this.document.visibilityState==='visible')void this.check();};
   this.document.addEventListener('visibilitychange',visible);
   this.document.defaultView?.addEventListener('focus',visible);
   const timer=this.zone.runOutsideAngular(()=>setInterval(()=>{if(this.document.visibilityState==='visible')void this.check();},30*1000));
   this.destroy.onDestroy(()=>{clearInterval(timer);this.document.removeEventListener('visibilitychange',visible);this.document.defaultView?.removeEventListener('focus',visible);});
  });
 }
 async check(){if(!this.worker?.isEnabled||this.checking)return;this.checking=true;try{if(await this.worker.checkForUpdate())this.zone.run(()=>this.available.set(true));}catch{/* A failed background check must not interrupt the current flow. */}finally{this.checking=false;}}
 async apply(){if(!this.available()||this.applying())return;this.applying.set(true);this.error.set('');try{await this.worker?.activateUpdate();this.reload();}catch{this.error.set('No se pudo actualizar. Inténtalo de nuevo cuando tengas conexión.');this.applying.set(false);}}
}
